import React, { useRef } from 'react';
import { images } from '../../../../Constants/ImageUrls';
import { convertPrice } from '../../../../Utils/ForeignUtils';
import { createRippleEffectRelative } from '../../../../Utils/helper';

import {
  FreeTag,
  ProductImageSection,
  TotalPriceInCart,
} from '../CartProducts/styled';
import {
  ChangeProduct,
  FreeProductCard,
  ItemDetail,
  VermArrow,
} from './styled';

export default function FreeProductInCart(props) {
  const { product, changeProductHandler, freeConsultationProduct } = props;
  const productImage = product?.images?.[0];
  const changeProductRef = useRef();
  const { symbol, price: productPrice } = convertPrice(product?.price);
  return freeConsultationProduct ? (
    <FreeProductCard onClick={() => changeProductHandler()}>
      <ItemDetail>
        <p className="product_name">{product?.nickname}</p>
        <ChangeProduct>
          <button
            ref={changeProductRef}
            onClick={(event) => {
              createRippleEffectRelative(event, changeProductRef.current);
            }}
          >
            Change Product
            <VermArrow src={images.pinkrightarrow} alt="verm arrow" />
          </button>
          <TotalPriceInCart>
            <>
              {symbol}
              {`${productPrice}`}
            </>
          </TotalPriceInCart>
        </ChangeProduct>
      </ItemDetail>
    </FreeProductCard>
  ) : (
    <FreeProductCard onClick={() => changeProductHandler()}>
      <ProductImageSection>
        <img src={productImage} alt="" className="product_image" />
        <FreeTag src="/images/freetag.svg" alt="" />
      </ProductImageSection>

      <ItemDetail>
        <p className="product_name">{product?.nickname}</p>
        <ChangeProduct>
          <button
            ref={changeProductRef}
            onClick={(event) => {
              createRippleEffectRelative(event, changeProductRef.current);
            }}
          >
            Change Product
            <VermArrow src={images.pinkrightarrow} alt="verm arrow" />
          </button>
          <TotalPriceInCart>
            <>
              {symbol}
              {`${productPrice}`}
            </>
          </TotalPriceInCart>
        </ChangeProduct>
      </ItemDetail>
    </FreeProductCard>
  );
}
